module.exports = __webpack_public_path__ + "img/people-1.1ea28324.png";